"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBetHomeAwayCompetitorsRenamed = exports.getHomeAwayCompetitorsRenamed = exports.formatCompetitorName = exports.joinCompetitorNames = void 0;
exports.getHomeAwayCompetitors = getHomeAwayCompetitors;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const constants_1 = require("./constants");
function getHomeAwayCompetitors(competitors, homeCompetitorIds) {
    return {
        homeCompetitors: competitors.filter((competitor) => homeCompetitorIds === null || homeCompetitorIds === void 0 ? void 0 : homeCompetitorIds.includes(competitor.id)),
        awayCompetitors: competitors.filter((competitor) => !(homeCompetitorIds === null || homeCompetitorIds === void 0 ? void 0 : homeCompetitorIds.includes(competitor.id))),
    };
}
const joinCompetitorNames = (competitors) => {
    return competitors.map((competitor) => competitor.name).join(' – ');
};
exports.joinCompetitorNames = joinCompetitorNames;
const formatCompetitorName = ({ name, eventType, status, eventDate, renameDate, }) => {
    try {
        if (!eventType ||
            !eventType.code ||
            eventType.code === constants_1.EventTypeWithDefaultName.Main) {
            return name;
        }
        const eventDateObj = eventDate ? new Date(eventDate) : undefined;
        const renameDateObj = renameDate ? new Date(renameDate) : undefined;
        // old name betEvent
        if (!status && eventDateObj && renameDateObj) {
            if (eventDateObj <= renameDateObj) {
                return name;
            }
        }
        const displayName = eventType.name;
        if (!displayName) {
            return name;
        }
        // old name eventResult
        if (status) {
            const isEndedOrClosed = status === betweb_openapi_axios_1.EventStatus.Ended || status === betweb_openapi_axios_1.EventStatus.Closed;
            if (isEndedOrClosed &&
                eventDateObj &&
                renameDateObj &&
                eventDateObj <= renameDateObj) {
                return name;
            }
        }
        return `${name} (${displayName})`;
    }
    catch (error) {
        console.error('Failed to format competitor name', {
            name,
            eventType,
            status,
            eventDate,
            renameDate,
            error,
        });
        return name;
    }
};
exports.formatCompetitorName = formatCompetitorName;
const getHomeAwayCompetitorsRenamed = ({ event, renameDate, isNewSbCompetitorsNameEnabled, }) => {
    if (!event) {
        return {
            homeCompetitors: [],
            awayCompetitors: [],
        };
    }
    const { competitors, homeCompetitorIds, eventType, status, eventDate } = event;
    const formatName = (competitor) => {
        if (!isNewSbCompetitorsNameEnabled || !renameDate) {
            return competitor;
        }
        return {
            ...competitor,
            name: (0, exports.formatCompetitorName)({
                name: competitor.name,
                eventType,
                status,
                eventDate,
                renameDate,
            }),
        };
    };
    return {
        homeCompetitors: competitors
            .filter((competitor) => homeCompetitorIds === null || homeCompetitorIds === void 0 ? void 0 : homeCompetitorIds.includes(competitor.id))
            .map(formatName),
        awayCompetitors: competitors
            .filter((competitor) => !(homeCompetitorIds === null || homeCompetitorIds === void 0 ? void 0 : homeCompetitorIds.includes(competitor.id)))
            .map(formatName),
    };
};
exports.getHomeAwayCompetitorsRenamed = getHomeAwayCompetitorsRenamed;
const getBetHomeAwayCompetitorsRenamed = ({ event, renameDate, isNewSbCompetitorsNameEnabled, }) => {
    if (!event) {
        return {
            homeCompetitors: [],
            awayCompetitors: [],
        };
    }
    const { competitors, eventType, eventDate } = event;
    const formatName = (competitor) => {
        if (!isNewSbCompetitorsNameEnabled || !renameDate) {
            return competitor;
        }
        return {
            ...competitor,
            name: (0, exports.formatCompetitorName)({
                name: competitor.name,
                eventType,
                status: undefined,
                eventDate,
                renameDate,
            }),
        };
    };
    const homeCompetitors = competitors
        .filter((competitor) => competitor.home)
        .map(formatName);
    const awayCompetitors = competitors
        .filter((competitor) => !competitor.home)
        .map(formatName);
    return { homeCompetitors, awayCompetitors };
};
exports.getBetHomeAwayCompetitorsRenamed = getBetHomeAwayCompetitorsRenamed;
//# sourceMappingURL=competitorNames.js.map